<template>
  <div>
    <v-dialog
      v-model="editPostOverlay"
      :overlay-opacity="opacity"
      content-class="create-campaign-con"
      :persistent="true"
    >
      <div class="view-edit-card">
        <div v-if="!showImage">
          <div class="flex header">
            <div class="flex">
              <v-icon
                @click="handleBackbtn"
                class="icon"
                color="#1F8F58"
                size="25"
              >
                mdi-arrow-left
              </v-icon>
              <h3 class="header-text">Edit posts</h3>
            </div>
            <v-btn
              v-if="this.postData.campaign_objective !== 'awareness'"
              @click="handleAddNewPostbtn"
              class="addNewPost"
              size="25"
              elevation="0"
              color="#1D8D56"
            >
              + Add a new post
            </v-btn>
          </div>
          <div
            v-if="items.length > 0 && postImage.length > 0"
            class="banners-con flex"
          >
            <div v-for="(item, i) in postImage" :key="i">
              <div class="img-card flex">
                <img
                  :style="{
                    filter: `${blurOrShowImage(!item.is_paused)}`,
                  }"
                  @click="handleImageClick(item, i)"
                  :src="item.image"
                  alt=""
                />

                <div class="flex" style="flex-direction: row;padding-bottom: 20px;">
                  <div style="padding-bottom: 16px; margin-right: 5px">
                    <v-btn
                      @click="generateDeeplink(item.post_id)"
                      elevation="0"
                      color="#f4f9f5"
                      small
                      >Copy Deep Link
                      <v-icon class="ml-2" size="19">
                        mdi-checkbox-multiple-blank-outline
                      </v-icon></v-btn
                    >
                  </div>
                  <div @click="toggleStatus(i)">
                    <p v-if="item.is_paused">
                      Resume
                      <v-icon class="pause-icon"> mdi-play </v-icon>
                    </p>
                    <p v-else>
                      Pause
                      <v-icon class="pause-icon">mdi-pause</v-icon>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="msg-con flex">
            <p>No image present for this campaign</p>
          </div>

          <!-- button section  -->
          <div class="button-section flex">
            <v-btn
              @click="closeAll"
              elevation="0"
              class="cancel-btn"
              color="#EBF5F0"
            >
              Cancel
            </v-btn>
            <v-btn
              elevation="0"
              @click="saveChanges()"
              class="edit-btn"
              color="#1D8D56"
            >
              SAVE CHANGES
            </v-btn>
          </div>
        </div>

        <!-- post id selection flow  -->
        <post-selection @campaignPostData="campaignPostData" :data="data" :fromEditpage="true" :postSelectionOverlay="postSelectionOverlay" @closePostSelectionOverlay="closePostSelectionOverlay"/>

        <div v-if="showImage">
          <div class="view-image-card">
            <div class="flex header">
              <div class="flex">
                <v-icon
                  @click="showImage = false"
                  class="icon"
                  color="#1F8F58"
                  size="25"
                >
                  mdi-arrow-left
                </v-icon>
                <h3 class="header-text">Edit posts</h3>
              </div>
            </div>

            <div class="image-con">
              <img
                :style="{
                  filter: `${blurOrShowImage(!selectedImage.is_paused)}`,
                }"
                :src="selectedImage.image"
              />

              <div class="pause-text-con" @click="toggleStatus(selectedId)">
                <p v-if="selectedImage.is_paused">
                  Resume
                  <v-icon class="pause-icon"> mdi-play </v-icon>
                </p>
                <p v-else>
                  Pause
                  <v-icon class="pause-icon"> mdi-pause </v-icon>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
    <!-- sucess page  -->
    <success-page :successOverlay="successOverlay" @closeAll="reloadApi" />
    <div v-if="createAdOverlay">
      <create-advertisement
        :data="data"
        :createAdOverlay="createAdOverlay"
        :cardSize="cardSize"
        :fromEditpage="true"
        :product="this.postData.product"
        @closeCreateAdOverlay="closeCreateAdOverlay"
        @cancelAdCreation="closeAll"
        @adData="handleAdData"
      />
    </div>
  </div>
</template>

<script>
import successPage from "./success-page.vue";
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
import createAdvertisement from "./create-advertisement.vue";
import postSelection from "./post-selection.vue";
export default {
  name: "editPosts",
  data() {
    return {
      isPlaying: true,
      showImage: false,
      successOverlay: false,
      opacity: 0,
      items: [],
      selectedImage: {},
      selectedId: null,
      isPaused: false,
      changedImage: [],
      dataforApi: this.data,
      postImage: [],
      createAdOverlay: false,
            postSelectionOverlay : false,

    };
  },
  props: {
    editPostOverlay: Boolean,
    // createAdOverlay: Boolean,
    data: Object,
    cardSize: Array,
    postData: Object,
  },





    watch: {
        editPostOverlay: function () {
            console.log("editPostOverlay", this.postData);
            this.postImage = [];
            this.items = this.postData.campaign_post;
            this.postData.campaign_post.map((item) => {
                const tempImage = {};
                tempImage.image = item.video ? item.video.image.medium : item.image;
                tempImage.post_id = item.id;
                tempImage.is_paused = item.is_paused;
                this.postImage.push(tempImage);
            });
            console.log("POST IMAGE", this.postImage);
        },
    },
    components: {
        "success-page": successPage,
        "create-advertisement": createAdvertisement,
        "post-selection" : postSelection,
    },

    methods: {
        // handle new changes and call api
        handleAdData(ADdata){
            this.showToast("New post added", "success", 10000);
            console.log("DATA", ADdata)
            if(this.postData.campaign_objective === 'lead_generation'){
                ADdata.map(item => {
                    item.cta_destination = this.postData.form;
                })
                this.dataforApi.form = this.postData.form;
            }
            
            // for product list send product id
            if(this.postData.campaign_objective === 'product_sale'){
                this.dataforApi.product = this.postData.product.id;
            }
            this.dataforApi.ads = ADdata;
        },
        campaignPostData(postData){
            console.log("POST DATA", postData);
            this.dataforApi.awareness_post_id = postData;
        },
        saveChanges() {
            this.generatePostStatus();
            const imageForApi = [];
            this.postImage.map((item) => {
                const temp = {};
                temp.post_id = item.post_id;
                temp.is_paused = item.is_paused;
                imageForApi.push(temp);
            });
            this.dataforApi.paused_post_id_list = imageForApi;
            this.editCampaign();
        },

        // add post with active status
        generatePostStatus() {
            this.changedImage = [];
            this.items.map((item) => {
                const tempImg = {};
                tempImg.post_id = item.id;
                tempImg.is_paused = item.is_paused;
                this.changedImage.push(tempImg);
            });
        },

        // toggle the pause and resume status of post
        toggleStatus(id) {
            console.log("BEFORE->", this.postImage[id].is_paused);
            this.postImage[id].is_paused = !this.postImage[id].is_paused;
            console.log("BEFORE->", this.postImage[id].is_paused);
        },

        // select a particular post with id
        handleImageClick(image, id) {
            this.selectedId = id;
            this.selectedImage = image;
            this.showImage = true;
        },

        // handle overlays
        handleAddNewPostbtn() {
            if(this.postData.campaign_objective != 'awareness'){
                this.createAdOverlay = true;
            } else {
                this.postSelectionOverlay = true;
            }
        },
        handleBackbtn() {
            this.$emit("closeEditOverlay");
        },
        closeCreateAdOverlay() {
            this.createAdOverlay = false;
        },
        closePostSelectionOverlay(){
            this.postSelectionOverlay = false;
        },
        closeAll() {
            this.$emit("closeAll");
        },
        reloadApi() {
            this.$emit("reloadApi");
        },

        // blur the image based on active status
        blurOrShowImage(target) {
            if (target == false) {
                return "opacity(30%)";
            } else {
                return "opacity(100%)";
            }
        },

        // edit campaign with changed data
        editCampaign() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.successOverlay = true;
                }
            };

            const errorHandler = (error) => {
                this.loader = false;
                console.log("ERROR ** ", error.response.data);
                    if (error.response.data.awareness_post_id) {
                        this.showToast(error.response.data.awareness_post_id[0], "error", 10000);
                    } else if (error.response.data.non_field_errors) {
                        this.showToast(error.response.data.non_field_errors[0], "error", 10000);
                    } else {
                        this.showToast("Something went wrong internally", "error", 10000);
                    }
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };
            console.log("DATA FOR API ---->", this.dataforApi);
            this.requestPOST(API_URL.editCampaign, this.dataforApi, headers, successHandler, errorHandler);
        },
    saveChanges() {
      this.generatePostStatus();
      const imageForApi = [];
      this.postImage.map((item) => {
        const temp = {};
        temp.post_id = item.post_id;
        temp.is_paused = item.is_paused;
        imageForApi.push(temp);
      });
      this.dataforApi.paused_post_id_list = imageForApi;
      this.editCampaign();
    },

    // add post with active status
    generatePostStatus() {
      this.changedImage = [];
      this.items.map((item) => {
        const tempImg = {};
        tempImg.post_id = item.id;
        tempImg.is_paused = item.is_paused;
        this.changedImage.push(tempImg);
      });
    },

    // toggle the pause and resume status of post
    toggleStatus(id) {
      console.log("BEFORE->", this.postImage[id].is_paused);
      this.postImage[id].is_paused = !this.postImage[id].is_paused;
      console.log("BEFORE->", this.postImage[id].is_paused);
    },

    // select a particular post with id
    handleImageClick(image, id) {
      this.selectedId = id;
      this.selectedImage = image;
      this.showImage = true;
    },

    // handle overlays
    handleAddNewPostbtn() {
      this.createAdOverlay = true;
    },
    handleBackbtn() {
      this.$emit("closeEditOverlay");
    },
    closeCreateAdOverlay() {
      this.createAdOverlay = false;
    },
    closeAll() {
      this.$emit("closeAll");
    },
    reloadApi() {
      this.$emit("reloadApi");
    },

    // blur the image based on active status
    blurOrShowImage(target) {
      if (target == false) {
        return "opacity(30%)";
      } else {
        return "opacity(100%)";
      }
    },

    // edit campaign with changed data
    editCampaign() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.successOverlay = true;
        }
      };

      const errorHandler = (error) => {
        this.loader = false;
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };
      console.log("DATA FOR API ---->", this.dataforApi);
      this.requestPOST(
        API_URL.editCampaign,
        this.dataforApi,
        headers,
        successHandler,
        errorHandler
      );
    },
    generateDeeplink(item) {
      console.log(item);
      this.getOrGenerateDeeplinkApiCall(item);
    },
    getOrGenerateDeeplinkApiCall(postId) {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log(response.data.url);
          navigator.clipboard.writeText(response.data.url);
          this.showToast("Deeplink Copied !", "success", 10000);
        }
      };
      const data = {
        content_id: postId,
        content_type: "clips",
      };
      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };
      this.requestPOST(
        `${API_URL.deeplink}`,
        data,
        headers,
        successHandler,
        errorHandler
      );
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  color: #445149;
  font-weight: 500;
  font-size: 14px;
}

.view-edit-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  height: 570px;
}
.header {
  justify-content: space-between;
  margin-bottom: 25px;
}
.header-text {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  color: #333333;
  margin-left: 15px;
}
.banners-con {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;

  margin-top: 20px;
  height: 460px;

  overflow-y: scroll;
  overflow-x: hidden;
  align-content: flex-start;
  img {
    min-width: 240px;
    max-width: 240px;
    min-height: 200px;
    max-height: 200px;
  }
}
.msg-con {
  width: 100%;
  height: 460px;
  justify-content: center;
  align-items: center;

  p {
    color: #445149;
  }
}
.img-card {
  width: 100%;
  height: 210px;
  object-fit: contain;
  justify-content: space-around;
  padding: 0px 0px 0px 0px;
  flex-direction: column;
  // background-color: #1d8d56;
  // p{
  //     marg
  // }
}
.button-section {
  justify-content: space-between;
  margin-top: 30px;
  margin-right: 10px;
  .v-btn {
    width: 45%;
    height: 56px !important;
    text-transform: capitalize !important;
    font-size: 1rem;
  }
}
.cancel-btn {
  color: #1d8d56 !important;
  font-size: 1rem;
}
.edit-btn {
  color: #ffffff;
}
img {
  border-style: none;
  padding-bottom: 5px;
  padding-top: 20px;
}
.addNewPost {
  color: #fff !important;
  height: 44px !important;
  border-radius: 8px;
  cursor: pointer;
  margin-left: 10px;
  text-transform: capitalize !important;
  font-size: 15px !important;
  font-weight: 500;
}

.pause-icon {
  font-size: 18px;
  margin-left: 5px;
}
.pause-icon-in-carousal {
  font-size: 2rem;
  margin-left: 5px;
}
.pause-text-con {
  margin-top: 20px;
  text-align: center;
  .v-icon,
  p {
    font-size: 1.5rem;
  }
}
.icon {
  background-color: #eff6f3;
  padding: 8px;
  border-radius: 6px;
}
.image-con {
  margin-top: 40px;
  height: 460px;
  width: 95%;

  img {
    object-fit: contain;
    max-height: 100%;
    width: 100%;
  }
}
.view-image-card {
  background-color: #ffffff;
  width: 800px;
  border-radius: 8px;
  height: 650px;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(50, 52, 65, 0.4);
  border: 2px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-track {
  display: none;
}
::-webkit-scrollbar-corner {
  display: none;
  height: 0px;
  width: 0px;
}
</style>

<style>
.create-campaign-con.v-dialog {
  width: 800px;
  height: 650px;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: none;
}
</style>
